export default __webpack_public_path__ + "static/media/18-days-voyage.e97725e3.jpg";